<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div v-if="!loading">
                    <data-table :headings="peopleToNotifyHeadings" :data="peopleToNotify" :hasActions="true"
                                :pagingDetails="pagingDetails"
                                :stateChanged="filterStateChanged"
                                @actionClicked="onCustomerVehicleActionClicked" @filterSearchClicked="onFilterSearchClicked">
                        <template #actionButton>
                            <div class="w-100">
                                <button class="btn btn-primary" @click="onAddPersonToNotifyClick">Add Person To Notify</button>
                            </div>
                        </template>
                        <template #filter>
                            <div class="p-3">
                                <div class="input-group pb-4">
                                    <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="filter.customerSearchQuery">
                                    <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="fas fa-search"></i>
                                    </span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6">
                                        <div>
                                            <label>
                                                Role
                                            </label>
                                            <bootstrap-select  :selectOptions="roles" :selectedOption="filter.selectedRole" :elementId="'roleFilterSelect'"
                                                               :returnSelectedOptionText="true"
                                                               @changeSelect="onRoleFilterSelect"></bootstrap-select>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="float-right">
                                            <active-inactive-radio-buttons :activeInactiveKey="filter.activeOrInactiveItems"
                                                                           :componentId="'customerFilterRadioButtons'"
                                                                           @activeInactiveSelected="onActiveInactiveFilterSelected"></active-inactive-radio-buttons>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        </template>
                    </data-table>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
    </div>

    <mark-as-active-inactive-modal
                :heading="personToNotifyMarkAsActiveInactiveModal.heading"
                :modalId="personToNotifyMarkAsActiveInactiveModal.modalId"
                :isSaving="personToNotifyMarkAsActiveInactiveModal.isSaving"
                :showModal="personToNotifyMarkAsActiveInactiveModal.showModal"
                :isActive="personToNotifyMarkAsActiveInactiveModal.isActive"
                @closeClicked="personToNotifyMarkAsActiveInactiveModal.showModal = false"
                @saveButtonClicked="onMarkAsActiveInactiveSaveClick"></mark-as-active-inactive-modal>
    
    <modal-form
            :heading="addOrUpdatePersonToNotifyModal.heading"
            :modalId="addOrUpdatePersonToNotifyModal.modalId"
            :isSaving="addOrUpdatePersonToNotifyModal.isSaving"
            :showModal="addOrUpdatePersonToNotifyModal.showModal"
            @closeClicked="onAddOrEditPersonToNotifyModalCloseClick"
            @saveButtonClicked="onAddOrEditPersonToNotifySaveClick">
        <template #form>
            <div class="form-group">
                <label for="firstNameInput">
                    First Name
                </label>
                <div class="text-danger" v-if="addOrUpdatePersonToNotifyModal.personToNotify.firstName.hasError">
                    {{addOrUpdatePersonToNotifyModal.personToNotify.firstName.errorMessage}}
                </div>
                <input type="text" class="form-control" id="firstNameInput" v-model="addOrUpdatePersonToNotifyModal.personToNotify.firstName.value">
            </div>
            <div class="form-group">
                <label for="lastNameInput">
                    Last Name
                </label>
                <div class="text-danger" v-if="addOrUpdatePersonToNotifyModal.personToNotify.lastName.hasError">
                    {{addOrUpdatePersonToNotifyModal.personToNotify.lastName.errorMessage}}
                </div>
                <input type="text" class="form-control" id="lastNameInput" v-model="addOrUpdatePersonToNotifyModal.personToNotify.lastName.value">
            </div>
            <div class="form-group">
                <label for="cellNumberInput">
                    Cell Number
                </label>
                <div class="text-danger" v-if="addOrUpdatePersonToNotifyModal.personToNotify.phoneNumber.hasError">
                    {{addOrUpdatePersonToNotifyModal.personToNotify.phoneNumber.errorMessage}}
                </div>
                <input type="text" class="form-control" id="cellNumberInput" v-maska data-maska="### ### ####" v-model="addOrUpdatePersonToNotifyModal.personToNotify.phoneNumber.value">
            </div>
            <div class="form-group">
                <label for="roleSelect">
                    Role
                </label>
                <div class="text-danger" v-if="addOrUpdatePersonToNotifyModal.personToNotify.roleId.hasError">
                    {{addOrUpdatePersonToNotifyModal.personToNotify.roleId.errorMessage}}
                </div>
                <bootstrap-select  :selectOptions="roles" :selectedOption="addOrUpdatePersonToNotifyModal.personToNotify.roleId.value" :elementId="'roleSelect'"
                                   :returnSelectedOptionText="true"
                                   @changeSelect="onRoleSelect"></bootstrap-select>
            </div>
            <div class="form-group">
                <label for="emailAddressInput">
                    Email Address
                </label>
                <div class="text-danger" v-if="addOrUpdatePersonToNotifyModal.personToNotify.emailAddress.hasError">
                    {{addOrUpdatePersonToNotifyModal.personToNotify.emailAddress.errorMessage}}
                </div>
                <input type="email" class="form-control" id="emailAddressInput" v-model="addOrUpdatePersonToNotifyModal.personToNotify.emailAddress.value">
            </div>
        </template>
    </modal-form>
</div>
